<template>
    <div class="role-list-wrapper ppv2-bg-white dark:ppv2-bg-dark">
        <div class="content !ppv2-pb-0 ppv2-flex ppv2-flex-col md:ppv2-flex-row ppv2-justify-between ppv2-items-center">
            <Header :title="$t('roles.title_v3')" />
            <SegmentedControl
                v-if="isSuperAdmin"
                v-model="type_fonctionnalite"
                :options="[
                    { label: $t('roles.switch_role_perm_fonct.toogle.permissions'), value: 'permission' },
                    { label: $t('roles.switch_role_perm_fonct.toogle.features'), value: 'feature' },
                ]"
                containerClass="ppv2-border ppv2-border-black !ppv2-p-[2px] !ppv2-bg-transparent !ppv2-rounded-[8px] md:ppv2-mb-0 ppv2-mb-5"
                customToggleOptionClass="!ppv2-py-1 !ppv2-rounded-[6px]"
                :containerStyle="{ width: 'fit-content', minWidth: '260px' }"
                activeColor="#7d2dbd"
            />
        </div>
        <div class="ppv2-pb-6">
            <div v-if="loading" class="ppv2-flex ppv2-justify-center ppv2-py-12">
                <v-progress-circular indeterminate color="#8b5cf6"></v-progress-circular>
            </div>

            <template v-else>
                <div class="table-wrap">
                    <table class="tbl">
                        <!-- ─── THEAD ─── -->
                        <thead>
                            <tr class="bg-purple ppv2-bg-opacity-[25%]">
                                <th class="th-perm ppv2-text-capitalize ppv2-text-black ppv2-text-sm">
                                    {{ $t('roles.permissions') }}
                                </th>
                                <th v-for="role in roles" :key="role.id" class="th-role">
                                    <button class="role-hd-btn" @click="toggleCol(role.name)">
                                        <span class="poppinsMedium ppv2-text-black ppv2-text-sm">{{
                                            getRoleDisplayName(role)
                                        }}</span>
                                        <div class="rcnt-row">
                                            <div
                                                class="cb-all"
                                                :class="getColHeaderClass(role.name)"
                                                :style="getColHeaderStyle(role.name)"
                                            ></div>
                                            <span class="ppv2-text-black poppinsRegular ppv2-text-sm">
                                                {{ getActiveCount(role.name) }}/{{ totalPermissionsCount }}
                                            </span>
                                        </div>
                                    </button>
                                </th>
                                <!--<th class="th-lock" :title="$t('roles.subscription_access')">
                                    <div
                                        style="
                                            display: flex;
                                            flex-direction: column;
                                            align-items: center;
                                            gap: 3px;
                                            padding: 10px 6px;
                                        "
                                    >
                                        <svg
                                            width="13"
                                            height="13"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="rgba(255,200,50,.5)"
                                            stroke-width="1.8"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <rect x="3" y="11" width="18" height="11" rx="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                        <span style="font-size: 10px; color: rgba(255, 200, 50, 0.45); letter-spacing: 0.04em"
                                            >{{ $t('roles.subscription_short') }}</span
                                        >
                                    </div>
                                </th>--><!--rendre invisible d'après theo, utilisé peermission fonctionnelle-->
                            </tr>
                        </thead>

                        <!-- ─── TBODY per category ─── -->
                        <tbody
                            v-for="category in categories"
                            :key="category.id"
                            v-show="isSuperAdmin || category.permissions.some((p) => isLocked(p.key_trans))"
                        >
                            <!-- Group header row -->
                            <tr class="grp-row">
                                <td :colspan="roles.length + 2" class="grp-td bg-purple ppv2-bg-opacity-10">
                                    <span class="grp-label">{{ getCategoryTranslation(category.key_trans) }}</span>
                                    <span class="grp-chevron">
                                        <svg
                                            viewBox="0 0 24 24"
                                            width="14"
                                            height="14"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <polyline points="6 9 12 15 18 9" />
                                        </svg>
                                    </span>
                                </td>
                            </tr>
                            <tr
                                v-for="(permission, pIdx) in category.permissions"
                                :key="permission.id"
                                class="prow hover:ppv2-bg-opacity-[5%] hover:bg-purple"
                                v-show="isSuperAdmin || isLocked(permission.key_trans)"
                                :class="{
                                    locked: !isLocked(permission.key_trans),
                                    'ppv2-bg-black ppv2-bg-opacity-[5%]': pIdx % 2 !== 0,
                                }"
                            >
                                <td class="td-perm">
                                    <span class="perm-index">{{ getGlobalIndex(category.id, pIdx) }}.</span>
                                    <span class="perm-label ppv2-text-black">{{
                                        getPermissionTranslation(permission.key_trans)
                                    }}</span>
                                </td>
                                <td v-for="role in roles" :key="role.id" class="td-role">
                                    <label class="cb-wrap">
                                        <input
                                            type="checkbox"
                                            class="cb"
                                            :checked="hasPermission(role.name, permission.key_trans)"
                                            :disabled="!isLocked(permission.key_trans)"
                                            :style="getCheckboxStyle(role.name, permission.key_trans)"
                                            @change="toggleCell(role.name, permission.key_trans)"
                                        />
                                    </label>
                                </td>
                                <!--<td class="td-lock">
                                    <button
                                        class="lock-btn"
                                        :class="!isLocked(permission.name) ? 'is-locked' : 'is-unlocked'"
                                        @click="toggleSubscription(permission.name)"
                                        v-if="isSuperAdmin"
                                        :title="
                                            !isLocked(permission.name) ? $t('roles.click_to_unlock') : $t('roles.click_to_lock')
                                        "
                                    >
                                        <svg v-if="!isLocked(permission.name)" viewBox="0 0 24 24">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                        <svg v-else viewBox="0 0 24 24">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 9.9-1" />
                                        </svg>
                                    </button>
                                </td>-->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>

        <!-- Fixed Save button bottom-right -->
        <div class="save-fab">
            <BaseButton
                :loading="saving"
                @click="saveMatrix"
                variant="primary"
                customClass="!ppv2-rounded-xl !ppv2-px-6 !ppv2-py-3 ppv2-shadow-lg"
            >
                {{ saving ? $t('common.saving') : $t('common.save') }}
            </BaseButton>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'
import BaseButton from '../../Shared/BaseButton.vue'
import { theme } from '../../../utils/theme'

import axios from 'axios'
import Header from '../../Shared/Header.vue'
import SegmentedControl from '../../Shared/SegmentedControl.vue'

export default {
    name: 'RoleList',
    components: {
        BaseButton,
        Header,
        SegmentedControl,
    },
    props: {
        token: {
            type: String,
            required: true,
        },
        tenant: {
            type: Object,
            required: true,
        },
        isSuperAdmin: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            saving: false,
            roles: [],
            categories: [],
            matrix: {}, // { roleName: [permName, ...] }
            subscription: {}, // { permName: isGivenBySuperAdmin (bool) }
            action_subs_by_user: {}, // { permName: isGivenBySuperAdmin (bool) }
            type_fonctionnalite: 'permission',
        }
    },
    computed: {
        roleColors() {
            if (this.isDark) {
                return {
                    Administrateur: '#a78bfa',
                    Manager: '#38bdf8',
                    Opérateur: '#ffffff',
                    Comptable: '#fbbf24',
                    // Keep old ones just in case
                    admin: '#a78bfa',
                    manager: '#38bdf8',
                    operator: '#ffffff',
                    accounter: '#fbbf24',
                }
            }
            return {
                Administrateur: '#8b5cf6',
                Manager: '#0ea5e9',
                Opérateur: '#000000',
                Comptable: '#D8AD00',
                // Keep old ones just in case
                admin: '#8b5cf6',
                manager: '#0ea5e9',
                operator: '#000000',
                accounter: '#D8AD00',
            }
        },
        themeMode() {
            return theme.mode
        },
        isDark() {
            return this.themeMode === 'dark'
        },
        totalPermissionsCount() {
            return this.categories.reduce((acc, cat) => {
                const count = cat.permissions.filter((p) => {
                    return this.isSuperAdmin || this.isLocked(p.key_trans)
                }).length
                return acc + count
            }, 0)
        },
        lockedPermissionsCount() {
            return Object.values(this.subscription).filter((v) => !v).length
        },
    },
    watch: {
        // This looks for changes in the BaseSwitch value
        type_fonctionnalite: {
            handler(newVal) {
                // We clear the matrix and categories to show the loading state
                // and avoid UI flickering with old data
                this.categories = []
                this.matrix = {}

                // Re-fetch data from the backend using the new type
                this.fetchData()
            },
            // 'immediate: false' is fine because mounted() already calls fetchData() once
        },
    },
    methods: {
        getCategoryTranslation(keyTrans) {
            return this.$te(`categories.${keyTrans}`) ? this.$t(`categories.${keyTrans}`) : keyTrans
        },
        getPermissionTranslation(keyTrans) {
            const key = keyTrans.replace(/^permissions\./, '')
            return this.$te(`permissions.${key}`) ? this.$t(`permissions.${key}`) : keyTrans
        },
        getRoleDisplayName(role) {
            const keys = {
                Administrateur: 'admin',
                Manager: 'manager',
                Opérateur: 'operator',
                Comptable: 'accounter',
            }
            const key = keys[role.display_name] || role.name
            return this.$te(`roles.names.${key}`) ? this.$t(`roles.names.${key}`) : role.display_name
        },
        normalizeSize,
        async fetchData() {
            this.loading = true
            try {
                const currentType = this.type_fonctionnalite
                const response = await axios.get('/api/v3/roles/data/matrix', {
                    params: { type: currentType },
                    headers: { Authorization: `Bearer ${this.token}` },
                })
                const { roles, categories, matrix } = response.data.data
                this.roles = roles
                this.categories = categories
                this.matrix = JSON.parse(JSON.stringify(matrix)) // Clone to avoid direct mutation

                // Initialize subscription state
                // Note: The backend should ideally provide this. For now, we'll assume all are unlocked (false)
                // unless we add is_given_by_super_admin to the API response.
                // Let's check if the permissions objects have it.
                const subscription = {}
                this.categories.forEach((cat) => {
                    cat.permissions.forEach((p) => {
                        subscription[p.key_trans] = p.min_plan_level <= this.tenant.plan_id || !!p.is_given_by_super_admin
                    })
                })
                this.subscription = subscription
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        async saveMatrix() {
            this.saving = true
            try {
                await axios.post(
                    '/api/v3/roles/data/matrix',
                    {
                        matrix: this.matrix,
                        subscription: this.action_subs_by_user,
                        type: this.type_fonctionnalite,
                    },
                    {
                        headers: { Authorization: `Bearer ${this.token}` },
                    }
                )
                if (this.$toast) {
                    this.$toast.success(this.$t('roles.messages.save_matrix_success'))
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                console.error('Error saving matrix:', error)
                if (this.$toast) {
                    this.$toast.error(this.$t('roles.errors.save_error'))
                }
            } finally {
                this.saving = false
            }
        },
        getRoleColor(roleName) {
            return this.roleColors[roleName] || '#94a3b8'
        },
        hasPermission(roleName, permissionName) {
            return this.matrix[roleName]?.includes(permissionName)
        },
        isLocked(permissionName) {
            return this.subscription[permissionName]
        },
        toggleCell(roleName, permissionName) {
            if (!this.isSuperAdmin && !this.isLocked(permissionName)) return

            if (!this.matrix[roleName]) {
                this.$set(this.matrix, roleName, [])
            }

            const index = this.matrix[roleName].indexOf(permissionName)
            if (index > -1) {
                this.matrix[roleName].splice(index, 1)
            } else {
                this.matrix[roleName].push(permissionName)
            }
        },
        toggleRow(permissionName) {
            if (!this.isSuperAdmin && !this.isLocked(permissionName)) return

            const anyOn = this.roles.some((r) => this.hasPermission(r.name, permissionName))
            this.roles.forEach((role) => {
                const hasPerm = this.hasPermission(role.name, permissionName)
                if (anyOn) {
                    // Turn all off
                    if (hasPerm) {
                        const idx = this.matrix[role.name].indexOf(permissionName)
                        this.matrix[role.name].splice(idx, 1)
                    }
                } else {
                    // Turn all on
                    if (!hasPerm) {
                        if (!this.matrix[role.name]) this.$set(this.matrix, role.name, [])
                        this.matrix[role.name].push(permissionName)
                    }
                }
            })
        },
        toggleCol(roleName) {
            const unlockedPermissions = []
            this.categories.forEach((cat) => {
                cat.permissions.forEach((p) => {
                    if (this.isSuperAdmin || this.isLocked(p.key_trans)) unlockedPermissions.push(p.key_trans)
                })
            })

            const activeCount = unlockedPermissions.filter((p) => this.hasPermission(roleName, p)).length
            const shouldTurnOn = activeCount < unlockedPermissions.length

            if (shouldTurnOn) {
                // Add all missing unlocked permissions
                unlockedPermissions.forEach((p) => {
                    if (!this.hasPermission(roleName, p)) {
                        if (!this.matrix[roleName]) this.$set(this.matrix, roleName, [])
                        this.matrix[roleName].push(p)
                    }
                })
            } else {
                // Remove all unlocked permissions
                unlockedPermissions.forEach((p) => {
                    const idx = this.matrix[roleName].indexOf(p)
                    if (idx > -1) this.matrix[roleName].splice(idx, 1)
                })
            }
        },
        toggleSubscription(permissionName) {
            this.action_subs_by_user[permissionName] = !this.subscription[permissionName]
            this.$set(this.subscription, permissionName, !this.subscription[permissionName])
        },
        getActiveCount(roleName) {
            return (this.matrix?.[roleName] || []).filter((permissionName) => this.isSuperAdmin || this.isLocked(permissionName))
                .length
        },
        getColHeaderClass(roleName) {
            const unlockedPermissions = []
            this.categories.forEach((cat) => {
                cat.permissions.forEach((p) => {
                    if (this.isSuperAdmin || this.isLocked(p.key_trans)) unlockedPermissions.push(p.key_trans)
                })
            })
            if (unlockedPermissions.length === 0) return ''
            const activeCount = unlockedPermissions.filter((p) => this.hasPermission(roleName, p)).length
            if (activeCount === 0) return ''
            if (activeCount === unlockedPermissions.length) return 'checked'
            return 'indeterminate'
        },
        getColHeaderStyle(roleName) {
            const color = this.getRoleColor(roleName)
            const cls = this.getColHeaderClass(roleName)
            const checkColor = roleName === 'Opérateur' && this.isDark ? '#000' : '#fff'
            if (cls === 'checked') return { background: color, border: '1.5px solid ' + color, '--cb-check-color': checkColor }
            if (cls === 'indeterminate')
                return { background: color + '40', border: '1.5px solid ' + color, '--cb-check-color': checkColor }
            return { border: '1.5px solid ' + color }
        },
        getCheckboxStyle(roleName, permissionName) {
            const color = this.getRoleColor(roleName)
            const checkColor = roleName === 'Opérateur' && this.isDark ? '#000' : '#fff'
            if (this.hasPermission(roleName, permissionName)) {
                return { background: color, borderColor: color, '--cb-check-color': checkColor }
            }
            return { border: '1.5px solid ' + color }
        },
        getGlobalIndex(catId, pIdx) {
            let offset = 0
            for (const cat of this.categories) {
                if (cat.id === catId) break
                offset += cat.permissions.length
            }
            return offset + pIdx + 1
        },
    },
    mounted() {
        this.fetchData()
    },
}
</script>

<style scoped>
/* ─── Table wrapper ─── */
.table-wrap {
    border-radius: 2px;
    overflow: auto;
}

.tbl {
    width: 100%;
    border-collapse: collapse;
    min-width: 700px;
}

/* ─── THEAD ─── */

th {
    padding: 0;
    white-space: nowrap;
    font-weight: 400;
}

.th-perm {
    padding: 14px 20px;
    text-align: left;
    letter-spacing: 0.08em;
    min-width: 300px;
}

.th-role {
    padding: 0;
    width: 120px;
    min-width: 100px;
    text-align: center;
}

.th-lock-h {
    width: 52px;
}

/* ─── Role header button ─── */
.role-hd-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 12px 14px 14px;
    width: 100%;
    transition: background 0.15s;
}
.role-hd-btn:hover {
    background: rgba(255, 255, 255, 0.04);
}

.rname {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.01em;
}

.rcnt-row {
    display: flex;
    align-items: center;
    gap: 5px;
}
.rdot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}
/* ─── Mini «select-all» checkbox in header ─── */
.cb-all {
    width: 14px;
    height: 14px;
    border-radius: 4px;
    border: 1.5px solid var(--cb-border);
    background: transparent;
    position: relative;
    transition: all 0.15s;
    margin-top: 2px;
}
.cb-all.checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 0px;
    width: 5px;
    height: 8px;
    border: 1.5px solid var(--cb-check-color, #fff);
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
}
.cb-all.indeterminate::after {
    content: '';
    position: absolute;
    left: 3px;
    top: 5px;
    width: 6px;
    height: 1.5px;
    background: var(--cb-check-color, #fff);
}

.dark .cb-all.indeterminate::after {
    background: var(--cb-check-color, #fff);
}

.grp-td {
    padding: 8px 20px;
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Override table-cell display for flex layout */
.grp-row .grp-td {
    display: table-cell;
}
.grp-label {
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0.03em;
    color: #475569;
}
.dark .grp-label {
    color: #aeaaaa;
}
.grp-chevron {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    color: #475569;
    vertical-align: middle;
}
.dark .grp-chevron {
    color: #aeaaaa;
}

/* ─── Permission rows ─── */
.prow {
    transition: background 0.12s;
}

.prow.is-locked-row {
    opacity: 0.4;
}

.prow td {
    padding: 2px 12px;
    vertical-align: middle;
}

/* Permission label cell */
.td-perm {
    padding-left: 20px !important;
    padding-right: 20px !important;
}
.perm-index {
    font-size: 12px;
    margin-right: 8px;
    font-weight: 500;
}
.perm-label {
    font-size: 13px;
    font-weight: 500;
}

/* Role checkbox cell */
.td-role {
    text-align: center;
    width: 120px;
}

/* Lock icon cell */
.td-lock {
    text-align: center;
    width: 52px;
    padding-right: 16px !important;
}
.lock-icon {
    width: 15px;
    height: 15px;
    stroke: rgba(255, 200, 50, 0.45);
    display: inline-block;
}
.lock-locked {
    stroke: rgba(255, 200, 50, 0.3);
}
.light .role-list-wrapper .lock-icon {
    stroke: rgba(180, 140, 0, 0.4);
}

/* ─── Checkbox ─── */
.cb-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    transition: background 0.1s;
}
.cb-wrap:hover {
    background: rgba(255, 255, 255, 0.06);
}

.cb {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1.5px solid var(--cb-border);
    background: transparent;
    cursor: pointer;
    position: relative;
    transition: all 0.15s;
    margin: 0;
}
.cb:checked::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 1px;
    width: 7px;
    height: 11px;
    border: 1.5px solid var(--cb-check-color, #fff);
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
}
.cb:disabled {
    cursor: not-allowed;
    opacity: 0.4;
}

/* ─── Fixed save button ─── */
.save-fab {
    position: fixed;
    right: 40px;
    bottom: 40px;
    z-index: 1000;
}

.stats {
    display: flex;
    flex-wrap: wrap;
}
.stat-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid #475569;
    border-radius: 10px;
    font-size: 13px;
}
.sdot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.sname {
    color: #475569;
    font-weight: 500;
}
.dark .sname {
    color: #aeaaaa;
    font-weight: 500;
}
.sval {
    color: #475569;
}
.dark .sval {
    color: #aeaaaa;
}
.sval strong {
    color: #475569;
    font-weight: 500;
}
.dark .sval strong {
    color: #aeaaaa;
    font-weight: 500;
}
</style>
